enum ApiErrorCodes {
  ERROR_AMOUNT_EXCEEDS_DESTINATION_EWALLET_LIMIT = 'ERROR_AMOUNT_EXCEEDS_DESTINATION_EWALLET_LIMIT',
  ERROR_EWALLET_TRANSFER_SOURCE_EWALLET_DISABLED = 'ERROR_EWALLET_TRANSFER_SOURCE_EWALLET_DISABLED',
  NOT_ENOUGH_FUNDS = 'NOT_ENOUGH_FUNDS',
  ERROR_INVALID_PARAMETERS = 'ERROR_INVALID_PARAMETERS',
  MERCHANT_PORTAL_USER_EXISTS = 'MERCHANT_PORTAL_USER_EXISTS',
  MERCHANTS_PORTAL_ERROR_SIGN_UP = 'MERCHANTS_PORTAL_ERROR_SIGN_UP',
  ERROR_UPDATE_USER_EWALLET_REFERENCE_ID_ALREADY_EXISTS = 'ERROR_UPDATE_USER_EWALLET_REFERENCE_ID_ALREADY_EXISTS',
  REQUEST_DECLINED = 'REQUEST_DECLINED',
  REQUEST_UNDER_REVIEW = 'REQUEST_UNDER_REVIEW',
  REQUEST_DECLINED_RP = 'REQUEST_DECLINED_RP',
  REQUEST_UNDER_REVIEW_RP = 'REQUEST_UNDER_REVIEW_RP',
  MERCHANTS_PORTAL_ERROR_NOT_ALLOWED_TO_ADD_VIRTUAL_IBAN = 'MERCHANTS_PORTAL_ERROR_NOT_ALLOWED_TO_ADD_VIRTUAL_IBAN',
  ERROR_CAPTURE_PAYMENT_IS_EXIPRED = 'ERROR_CAPTURE_PAYMENT_IS_EXIPRED',
  ERROR_AUTH_ONLY_IS_NOT_SUPPORTED = 'ERROR_AUTH_ONLY_IS_NOT_SUPPORTED',
  ERROR_CREATE_PAYMENT_METHOD = 'ERROR_CREATE_PAYMENT_METHOD',
  MERCHANTS_PORTAL_ERROR_KORTA_INVALID_CONTENT_REQUEST = 'MERCHANTS_PORTAL_ERROR_KORTA_INVALID_CONTENT_REQUEST',
  MERCHANTS_PORTAL_ERROR_USER_PENDING = 'MERCHANTS_PORTAL_ERROR_USER_PENDING',
  MERCHANTS_PORTAL_ERROR_ACCOUNT_SUSPEND = 'MERCHANTS_PORTAL_ERROR_ACCOUNT_SUSPEND',
  MERCHANTS_PORTAL_ERROR_MAX_LOGIN_ATTEMPTS = 'MERCHANTS_PORTAL_ERROR_MAX_LOGIN_ATTEMPTS',
}
export default ApiErrorCodes;

export enum ApiErrorCategories {
  MERCHANTS_PORTAL_ERROR_CREATE_PAYOUT = 'MERCHANTS_PORTAL_ERROR_CREATE_PAYOUT',
  ERROR_MERCHANTS_PORTAL_CREATE_REFUND = 'ERROR_MERCHANTS_PORTAL_CREATE_REFUND',
  MERCHANTS_PORTAL_ERROR_CREATE_EWALLET = 'MERCHANTS_PORTAL_ERROR_CREATE_EWALLET',
  MERCHANTS_PORTAL_ERROR_WALLET_CONTACT = 'MERCHANTS_PORTAL_ERROR_WALLET_CONTACT',
  MERCHANTS_PORTAL_ERROR_EWALLET_TRANSACTIONS = 'MERCHANTS_PORTAL_ERROR_EWALLET_TRANSACTIONS',
  MERCHANTS_PORTAL_ERROR_PAYMENT = 'MERCHANTS_PORTAL_ERROR_PAYMENT',
  MERCHANTS_PORTAL_ERROR_PAYMENT_PROCESSING_CARD = 'MERCHANTS_PORTAL_ERROR_PAYMENT_PROCESSING_CARD',
  MERCHANTS_PORTAL_ERROR_PAYOUT = 'MERCHANTS_PORTAL_ERROR_PAYOUT',
}

export const ApiErrorCategoriesMessages = {
  [ApiErrorCategories.MERCHANTS_PORTAL_ERROR_CREATE_PAYOUT]: {
    docLink: 'https://docs.rapyd.net/build-with-rapyd/reference/payout-object#payout-errors-1',
  },
  [ApiErrorCategories.ERROR_MERCHANTS_PORTAL_CREATE_REFUND]: {
    docLink: 'https://docs.rapyd.net/build-with-rapyd/reference/refund-object#refund-errors',
  },
  [ApiErrorCategories.MERCHANTS_PORTAL_ERROR_CREATE_EWALLET]: {
    docLink: 'https://docs.rapyd.net/build-with-rapyd/reference/wallet-object#wallet-errors',
  },
  [ApiErrorCategories.MERCHANTS_PORTAL_ERROR_WALLET_CONTACT]: {
    docLink:
      'https://docs.rapyd.net/build-with-rapyd/reference/wallet-contact-object#wallet-contact-errors',
  },
  [ApiErrorCategories.MERCHANTS_PORTAL_ERROR_EWALLET_TRANSACTIONS]: {
    docLink:
      'https://docs.rapyd.net/build-with-rapyd/reference/wallet-transaction-object#wallet-transaction-errors',
  },
  [ApiErrorCategories.MERCHANTS_PORTAL_ERROR_PAYMENT]: {
    docLink: 'https://docs.rapyd.net/build-with-rapyd/reference/payment-object#payment-errors',
  },
  [ApiErrorCategories.MERCHANTS_PORTAL_ERROR_PAYMENT_PROCESSING_CARD]: {
    docLink:
      'https://docs.rapyd.net/build-with-rapyd/reference/error-messages#card-network-error-messages',
  },
  [ApiErrorCategories.MERCHANTS_PORTAL_ERROR_PAYOUT]: {
    docLink: 'https://docs.rapyd.net/build-with-rapyd/reference/payout-object#payout-errors-1',
  },
};
